exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".button-file .file-list .file-list-item[data-v-57ea09fe]{display:-webkit-box;display:-ms-flexbox;display:flex;width:360px}.button-file .file-list .file-list-item .name[data-v-57ea09fe]{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;font-size:14px;padding-right:20px}.button-file .file-list .file-list-item .name i[data-v-57ea09fe]{margin-right:5px}.button-file .file-list .file-list-item .icon[data-v-57ea09fe]{padding:0 8px 0 5px;font-size:16px}.button-file .file-list .file-list-item[data-v-57ea09fe]:hover{background-color:#f5f7fa;cursor:pointer}\n", ""]);

// exports
